export const PROCESOS_WORKFLOW_LIST_PATH = '/procesos/workflow';
export const PROCESOS_WORKFLOW_PAGE_SIZE = 10;

export interface ProcesosWorkflowLocationState {
  procesosSearch?: string;
  returnPath?: string;
  workflowNombre?: string;
}

export function readProcesosReturnSearch(state: unknown): string {
  return (state as ProcesosWorkflowLocationState | null)?.procesosSearch ?? '';
}

export function procesosWorkflowListPath(search = ''): string {
  const query = search.startsWith('?') ? search : search ? `?${search}` : '';
  return `${PROCESOS_WORKFLOW_LIST_PATH}${query}`;
}

export function procesosWorkflowDetailPath(workflowId: number | string, search = ''): string {
  const query = search.startsWith('?') ? search : search ? `?${search}` : '';
  return `${PROCESOS_WORKFLOW_LIST_PATH}/${workflowId}${query}`;
}

export function generarProcesosWorkflowUrl(workflowId: number | string): string {
  return `api/profase-workflows/${workflowId}/generar-procesos`;
}

export function anularProcesosWorkflowUrl(workflowId: number | string): string {
  return `api/profase-workflows/${workflowId}/anular`;
}

export function procesosWorkflowNombreFilters(search: string): { filterName: string; filterValue: string }[] {
  const q = search.trim();
  return q ? [{ filterName: 'nombre', filterValue: q }] : [];
}

export function parseProcesosWorkflowId(pathname: string): number | null {
  const match = pathname.match(/^\/procesos\/workflow\/(\d+)$/);
  if (!match) return null;
  const id = Number(match[1]);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function withWorkflowIdFilter(
  filters: { filterName: string; filterValue: string }[],
  workflowId: number | null,
): { filterName: string; filterValue: string }[] {
  const without = filters.filter(f => f.filterName !== 'workflowId');
  if (workflowId == null) return without;
  return [...without, { filterName: 'workflowId', filterValue: String(workflowId) }];
}

interface PeriodoSortable {
  id?: number;
  periodo?: {
    desde?: string;
    fecha?: string;
    anio?: number;
    numero?: number;
  } | null;
}

function periodoInstanciaSortKey(row: PeriodoSortable): string {
  const periodo = row.periodo;
  if (!periodo) return '';
  if (periodo.desde) return periodo.desde;
  if (periodo.fecha) return periodo.fecha;
  if (periodo.anio != null && periodo.numero != null) {
    return `${periodo.anio}-${String(periodo.numero).padStart(4, '0')}`;
  }
  return '';
}

export function sortPeriodoInstanciasNewestFirst<T extends PeriodoSortable>(instancias: T[]): T[] {
  return [...instancias].sort((a, b) => {
    const byDate = periodoInstanciaSortKey(b).localeCompare(periodoInstanciaSortKey(a));
    if (byDate !== 0) return byDate;
    return (Number(b.id) || 0) - (Number(a.id) || 0);
  });
}
